"use client";

import { BigAudioPlayer } from "@/components/audioPlayers/BigAudioPlayer";
import { DownloadConversion } from "@/components/audioPlayers/downloadAudio/DownloadConversion";
import { SaveAudio } from "@/components/audioPlayers/SaveAudio";
import { SoftText } from "@/components/text/SoftText";
import { ConversionConstructedNoDates, UserNoDates } from "@/types/types";
import { useIsImpersonating } from "@/utils/impersonation/useIsImpersonating";
import { canUseLibrary } from "@/utils/subscriptionLevels/canUseLibrary";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";

export function DoneConversion({
  conversion,
  user,
}: {
  conversion: ConversionConstructedNoDates;
  user: UserNoDates;
}) {
  const isImpersonating = useIsImpersonating();

  const subscriptionPlan = getSubscriptionPlan(user.stripeSubscriptionId);
  const canSaveConversion =
    subscriptionPlan === null ? false : canUseLibrary(subscriptionPlan);

  const shouldShowInputWaveform =
    isImpersonating && conversion.inputSound !== null;

  return (
    <div>
      {shouldShowInputWaveform && (
        <>
          <div className="mb-1">
            <SoftText elementType="span">Input</SoftText>
          </div>
          <BigAudioPlayer
            source={conversion.inputSound!.presignedUrlPlay}
            bigWaves={false}
            className="w-full"
            includePreviewText={false}
            filename={null}
          />
          <div className="mt-4">
            <SoftText elementType="span">Output</SoftText>
          </div>
        </>
      )}
      <div className="flex items-center gap-x-3">
        <BigAudioPlayer
          source={conversion.outputSoundMp3!.presignedUrlPlay}
          bigWaves={false}
          className="w-full"
          includePreviewText={false}
          filename={null}
        />
        {canSaveConversion && (
          <SaveAudio
            type="conversion"
            entity={conversion}
            confirmOnUnsave={false}
          />
        )}

        <DownloadConversion conversion={conversion} />
      </div>
    </div>
  );
}
